import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Legal() {
  return (
    <div className="relative">
      <Navbar forceLight />
      <main className="bg-white">
        {/* Hero */}
        <section className="relative bg-[#f8f6f3] py-20 md:py-28">
          <div className="px-6 md:px-10 lg:px-16 max-w-5xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-[#1a1a1a] mb-4">
              Aviso Legal
            </h1>
            <p className="text-sm md:text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
              Información legal y condiciones de uso del sitio web de Esencia&co.
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 md:py-24">
          <div className="px-6 md:px-10 lg:px-16 max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  1. Identificación del Titular
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  El presente sitio web es propiedad de Esencia&co., empresa dedicada a la comercialización de insumos para perfumería fina, con domicilio en Av. de las Américas # 62-11, Bogotá, Colombia. Correo electrónico de contacto: comercial@esenciayco.co. Teléfono: +57 311 2245754.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  2. Objeto del Sitio Web
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Este sitio web tiene como finalidad principal proporcionar información sobre los productos y servicios ofrecidos por Esencia&co., incluyendo insumos para perfumería fina, esencias, fragancias, materias primas aromáticas y servicios de asesoría formulación. Asimismo, permite a los usuarios contactar a la empresa, solicitar cotizaciones y conocer la trayectoria de la compañía en el sector.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  3. Condiciones de Uso
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                  El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación plena y sin reservas de todas las condiciones incluidas en este aviso legal. El usuario se compromete a utilizar el sitio y sus servicios de conformidad con la ley, la moral, el orden público y las presentes condiciones, absteniéndose de:
                </p>
                <ul className="list-disc pl-6 text-sm md:text-base text-gray-600 leading-relaxed space-y-2">
                  <li>Utilizar los contenidos con fines ilícitos o contrarios a lo establecido en este aviso legal</li>
                  <li>Reproducir, copiar, distribuir, transformar o modificar los contenidos sin autorización expresa de Esencia&co.</li>
                  <li>Introducir virus, malware o cualquier otro código informático que pueda dañar el funcionamiento del sitio</li>
                  <li>Realizar actividades que supongan una sobrecarga indebida de los sistemas</li>
                </ul>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  4. Propiedad Intelectual e Industrial
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Todos los contenidos del sitio web, incluyendo textos, fotografías, gráficos, logotipos, iconos, software y cualquier otro material, son propiedad de Esencia&co. o de sus licenciantes y están protegidos por las leyes de propiedad intelectual e industrial. Queda prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otro uso de los contenidos sin autorización previa y expresa por escrito.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  5. Exclusión de Responsabilidad
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                  Esencia&co. no se responsabiliza de:
                </p>
                <ul className="list-disc pl-6 text-sm md:text-base text-gray-600 leading-relaxed space-y-2">
                  <li>Los daños y perjuicios que pudieran derivarse de interferencias, omisiones, interrupciones o fallos en el funcionamiento del sitio web</li>
                  <li>Retrasos o bloqueos en el funcionamiento del sistema causados por deficiencias o sobrecargas de líneas telefónicas o redes</li>
                  <li>Los daños causados por terceras personas mediante intromisiones ilegítimas fuera del control de Esencia&co.</li>
                  <li>La exactitud, veracidad y actualidad de los contenidos de sitios web externos a los que se pueda acceder mediante enlaces desde este portal</li>
                </ul>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  6. Enlaces a Terceros
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Este sitio web puede contener enlaces a páginas de terceros. Esencia&co. no asume responsabilidad alguna sobre los contenidos, productos, servicios, políticas de privacidad o prácticas de dichos sitios externos. La inclusión de cualquier enlace no implica necesariamente una relación de colaboración o respaldo por parte de Esencia&co.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  7. Legislación Aplicable y Jurisdicción
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Las presentes condiciones se rigen por la legislación de la República de Colombia. Para la resolución de cualquier controversia que pudiera derivarse del acceso o uso del sitio web, el usuario y Esencia&co. se someten a los juzgados y tribunales de Bogotá, Colombia, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  8. Modificaciones
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Esencia&co. se reserva el derecho de modificar unilateralmente, en cualquier momento y sin previo aviso, la estructura y diseño del sitio web, así como las presentes condiciones de uso. Cualquier modificación entrará en vigor desde su publicación en el sitio.
                </p>
              </div>

              <div>
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  9. Contacto
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Para cualquier consulta relacionada con este aviso legal, puedes contactarnos a través del correo electrónico comercial@esenciayco.co o llamando al +57 311 2245754.
                </p>
              </div>
            </div>

            <div className="mt-16 pt-8 border-t border-gray-200">
              <p className="text-xs text-gray-400 text-center">
                Última actualización: mayo 2026
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}